import {useCallback, useContext} from 'react';
import Honeybadger from '@honeybadger-io/js';
import MemberContext from '../contexts/MemberContext';
import generateSegmentData from '../utils/generateSegmentData';
import {getDaysUntilDate} from '../utils/dateUtils';

/*
  This hook is for generic tracking events.
  TrackingPlan events should go in the useTrackingPlan hook.
*/
const useSegment = () => {
  const {member} = useContext(MemberContext);

  const trackSegmentData = useCallback(
    ({pageName, eventName, eventData = {}}) => {
      if (!window || !window.analytics) {
        return;
      }

      const {page, track, user} = window.analytics;
      const {href: url, pathname: path} = window.location;

      const userTraits = user ? user().traits() : {};

      // ensure the userTraits.weddingSize is defined if we have
      // a defined guest count on the member context.
      if (user && !userTraits?.weddingSize && member?.number_of_guests) {
        userTraits.weddingSize = member.number_of_guests.replace('–', '-');
      }

      const context = {
        traits: userTraits || {},
        page: {path, url},
      };

      const args = eventData;

      if (member?.wedding_date) {
        args.daysUntilWedding = getDaysUntilDate(member.wedding_date);
      }

      const props = generateSegmentData(args);

      try {
        if (pageName) {
          page(pageName, {...props, ...userTraits, path, url});
        } else {
          track(eventName, props, context);
        }
      } catch (err) {
        // Analytics failures must not break product flows (e.g. transfer onSuccess).
        Honeybadger.notify(err, 'SegmentTrackError');
      }
    },
    [member],
  );

  return {trackSegmentData};
};

export default useSegment;
